import React, { createContext, useContext, useState, useEffect } from 'react';

const CountryContext = createContext();

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry deve essere usato all\'interno di CountryProvider');
  }
  return context;
};

export const CountryProvider = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState('IT');

  // Carica il paese salvato dal localStorage al caricamento
  useEffect(() => {
    const savedCountry = localStorage.getItem('selectedCountry');
    if (savedCountry) {
      setSelectedCountry(savedCountry);
    }
  }, []);

  // Salva il paese nel localStorage quando cambia
  const updateCountry = (country) => {
    setSelectedCountry(country);
    localStorage.setItem('selectedCountry', country);
  };

  const value = {
    selectedCountry,
    updateCountry
  };

  return (
    <CountryContext.Provider value={value}>
      {children}
    </CountryContext.Provider>
  );
}; 